const layout = document.querySelector('.layout');

if (layout.classList.contains('result-page')) {
    const allValues = Object.keys(localStorage)
        .filter((key) => key.startsWith('step'))
        .map((key) => parseInt(localStorage.getItem(key), 10));

    const sum = allValues.reduce((acc, currentValue) => acc + currentValue, 0);
    localStorage.setItem('result', sum);

    console.log('Result: ', sum);

    const numResultElement = document.querySelector('#numResult');
    numResultElement.textContent = sum;

    const result1 = document.querySelector('#result1'),
          result2 = document.querySelector('#result2'),
          result3 = document.querySelector('#result3');

    if (sum >= 0 && sum <= 3) {
        result1.classList.remove('hidden');
    } else if (sum >= 4 && sum <= 6) {
        result2.classList.remove('hidden');
    } else if (sum >= 7) {
        result3.classList.remove('hidden');
    }

}